$(document).on("turbolinks:load", () => {
  $(".add_task_type_to_group").click(function () {
    $(".task_type_id_selector").select2();
  });
});
